import ProductSearchResultsHtml from '../../app-lite/products/templates/product.search.results.html';

export function BookingAppointmentTypeCtrl ($uibModalInstance, $scope, $translate, $window, workshopAPI, messages, appointmentType) {

  $scope.appointmentType                 = appointmentType;
  $scope.appointmentType.estimated_hours = parseFloat($scope.appointmentType.estimated_hours || 0);

  $scope.saveAppointmentType = function () {
    var method = $scope.appointmentType.id ? 'patch' : 'post';

    workshopAPI[method]('/appointment_type', $scope.appointmentType).then(function () {
      $uibModalInstance.close('Appointment Type Saved');
    }, function (err) {
      messages.error(err);
    });
  }

  $scope.deleteAppointmentType = function () {
    workshopAPI.delete('/appointment_type', $scope.appointmentType.id)
      .then(function () {
        $uibModalInstance.close('Appointment Type Deleted');
      }, function (err) {
        messages.error(err);
      });
  }

  $scope.productSearch = {
    value: {
      item_code: $scope.appointmentType.product_item_code,
      id: $scope.appointmentType.product_id
    },
    templateUrl: ProductSearchResultsHtml,
    query: function (value) {
      return workshopAPI.get('/products/product_labor_list', [ value, 0, 5]);
    },
    choose: function (product) {
      $scope.appointmentType.product_item_code = product.item_code;
      $scope.appointmentType.product_id = product.id;
    },
    format: function (value) {
      return value;
    }
  }
}
